import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import ClockIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ClockIconPath";
import styles from "./TimeAddOn.module.css";

type TimeAddOnProps = {
  children: string;
};

function TimeAddOn({ children }: TimeAddOnProps) {
  return (
    <div className={styles["root"]}>
      <FixaSSRIcon paths={ClockIconPath} className={styles["icon"]!} />
      <FixaText textStyle={"Body.S"}>{children}</FixaText>
    </div>
  );
}

export default TimeAddOn;
